'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetWrapperDiv = exports.WidgetManager = exports.WidgetManagerContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WidgetWrapperLocatio;

var _templateObject = _taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n'], ['\n  height: 100%;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  &.inline {\n    height: 100%;\n    margin-top: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  &.inline {\n    height: 100%;\n    margin-top: 0;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    margin-left: 0;\n    margin-right: 24px;\n  '], ['\n    margin-left: 0;\n    margin-right: 24px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    margin-left: 24px;\n    margin-right: 0;\n  '], ['\n    margin-left: 24px;\n    margin-right: 0;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  background: ', ';\n  border-radius: 8px;\n  box-shadow: 0 5px 40px rgba(0, 0, 0, 0.1);\n  position: relative;\n  width: 376px;\n  &.inline {\n    box-shadow: none;\n    height: 100%;\n    margin: 0;\n    width: 100%;\n    border-radius: 0;\n  }\n  ', '\n'], ['\n  background: ', ';\n  border-radius: 8px;\n  box-shadow: 0 5px 40px rgba(0, 0, 0, 0.1);\n  position: relative;\n  width: 376px;\n  &.inline {\n    box-shadow: none;\n    height: 100%;\n    margin: 0;\n    width: 100%;\n    border-radius: 0;\n  }\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _WidgetLocations = require('../visitor-widget/constants/WidgetLocations');

var _calculateChatWidgetHeight = require('ui-addon-conversations/widget-dimensions/util/calculateChatWidgetHeight');

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sizes = {
  small: 'small',
  'extra-small': 'extra-small',
  default: 'default'
};

var WidgetManagerContent = exports.WidgetManagerContent = _styledComponents2.default.div.withConfig({
  displayName: 'VisitorWidgetStyleWrapper__WidgetManagerContent'
})(_templateObject);

var WidgetManager = exports.WidgetManager = _styledComponents2.default.div.withConfig({
  displayName: 'VisitorWidgetStyleWrapper__WidgetManager'
})(_templateObject2);

var WidgetWrapperLocation = (_WidgetWrapperLocatio = {}, _defineProperty(_WidgetWrapperLocatio, _WidgetLocations.LEFT_ALIGNED, (0, _styledComponents.css)(_templateObject3)), _defineProperty(_WidgetWrapperLocatio, _WidgetLocations.RIGHT_ALIGNED, (0, _styledComponents.css)(_templateObject4)), _WidgetWrapperLocatio);

var WidgetWrapperDiv = exports.WidgetWrapperDiv = _styledComponents2.default.div.withConfig({
  displayName: 'VisitorWidgetStyleWrapper__WidgetWrapperDiv'
})(_templateObject5, _colors.OLAF, function (_ref) {
  var widgetLocation = _ref.widgetLocation;
  return WidgetWrapperLocation[widgetLocation] || WidgetWrapperLocation[_WidgetLocations.RIGHT_ALIGNED];
});

var VisitorWidgetStyleWrapper = function (_Component) {
  _inherits(VisitorWidgetStyleWrapper, _Component);

  function VisitorWidgetStyleWrapper() {
    _classCallCheck(this, VisitorWidgetStyleWrapper);

    return _possibleConstructorReturn(this, (VisitorWidgetStyleWrapper.__proto__ || Object.getPrototypeOf(VisitorWidgetStyleWrapper)).apply(this, arguments));
  }

  _createClass(VisitorWidgetStyleWrapper, [{
    key: 'getChatWidgetStyle',
    value: function getChatWidgetStyle() {
      var _props = this.props,
          mobile = _props.mobile,
          inline = _props.inline,
          browserWindowHeight = _props.browserWindowHeight,
          showCloseButton = _props.showCloseButton;

      if (inline) {
        return { height: '100%' };
      }
      if (!mobile) {
        return {
          height: (0, _calculateChatWidgetHeight.calculateChatWidgetHeight)(browserWindowHeight, {
            showCloseButton: showCloseButton
          }) + 'px'
        };
      }
      return {};
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          inline = _props2.inline,
          isOpen = _props2.isOpen,
          size = _props2.size,
          style = _props2.style,
          mobile = _props2.mobile,
          widgetLocation = _props2.widgetLocation;


      if (!isOpen) {
        return null;
      }

      var widgetManagerClassNames = (0, _classNames2.default)('widget-manager', {
        inline: inline,
        small: size === sizes.small,
        'extra-small': size === sizes['extra-small']
      });

      return _react2.default.createElement(
        WidgetManager,
        { className: widgetManagerClassNames, style: style },
        _react2.default.createElement(
          WidgetManagerContent,
          null,
          _react2.default.createElement(
            WidgetWrapperDiv,
            {
              className: (0, _classNames2.default)('chat-widget', { mobile: mobile, inline: inline }, className),
              style: this.getChatWidgetStyle(),
              widgetLocation: widgetLocation
            },
            this.props.children
          )
        )
      );
    }
  }]);

  return VisitorWidgetStyleWrapper;
}(_react.Component);

VisitorWidgetStyleWrapper.propTypes = {
  browserWindowHeight: _react.PropTypes.number.isRequired,
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool,
  showCloseButton: _react.PropTypes.bool,
  size: _react.PropTypes.oneOf(Object.keys(sizes)).isRequired,
  style: _react.PropTypes.object,
  widgetLocation: _WidgetLocations.WidgetLocationProp
};

VisitorWidgetStyleWrapper.defaultProps = {
  inline: false,
  isOpen: false,
  showCloseButton: true,
  size: sizes.default
};

exports.default = VisitorWidgetStyleWrapper;